var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4053254,0,0,1.4053254,-1.0133136,-1.0133136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.3,2.5 C 17.6,2.5 2.5,17.7 2.5,36.3 2.5,55 17.7,70.1 36.3,70.1 55,70.1 70.1,54.9 70.1,36.3 70.1,17.6 55,2.5 36.3,2.5 Z M 48.9,31.1 34.7,45.3 C 34.3,45.8 33.6,46 33,46 32.4,46 31.7,45.7 31.3,45.3 l -7.6,-7.6 c -0.9,-0.9 -0.9,-2.5 0,-3.4 0.9,-0.9 2.5,-0.9 3.4,0 L 33,40.2 45.5,27.7 c 0.9,-0.9 2.5,-0.9 3.4,0 0.9,0.9 0.9,2.5 0,3.4 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.93fb30be6a66325c291fa7b7d5147b85.svg";
export { ForwardRef as ReactComponent };